import styled from 'astroturf/react'
import { useEffect } from 'react'
import { Button } from '@calendly/ui/components/button'
import { useParams } from 'react-router-dom'

import { useI18n } from 'locales'

import { usePurchasedPackageData } from '../../../../hooks/usePurchasedPackageData'
import _DetailsWrapper from "package_details-DetailsWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/new_confirmation/package_details.js?styleId=DetailsWrapper";
import _Message from "package_details-Message.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/new_confirmation/package_details.js?styleId=Message";
import _ButtonWrapper from "package_details-ButtonWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/pages/new_confirmation/package_details.js?styleId=ButtonWrapper";


const PackageDetails = ({ eventTypeUuid }) => {
  const { profileSlug, eventTypeSlug } = useParams()
  const { purchasedPackage, remainingSessions, refetch } = usePurchasedPackageData(eventTypeUuid)
  const { i18n } = useI18n()

  const bookAgain = () => {
    window.location.href = `/${profileSlug}/${eventTypeSlug}?redeem=${purchasedPackage.uuid}`
  }

  const purchaseAgain = () => {
    window.location.href = `/${profileSlug}/packages/${purchasedPackage.package_uuid}`
  }

  useEffect(() => {
    if (!eventTypeUuid || !purchasedPackage?.uuid) return
    refetch()
  }, [eventTypeUuid, purchasedPackage?.uuid, refetch])

  if (!purchasedPackage) return null

  return (
    <>
      {remainingSessions != null && remainingSessions > 0 && (
        <DetailsWrapper>
          <Message>
            {i18n.t('booking.package_success.sessions_remaining', {
              count: remainingSessions,
              package_name: purchasedPackage.name
            })}
          </Message>
          <ButtonWrapper>
            <Button onClick={bookAgain}>
              {i18n.t('booking.package_success.book_another_button')}
            </Button>
          </ButtonWrapper>
        </DetailsWrapper>
      )}

      {remainingSessions === 0 && (
        <DetailsWrapper>
          <Message>
            {i18n.t('booking.package_success.no_sessions_message')}
          </Message>
          <ButtonWrapper>
            <Button onClick={purchaseAgain}>
              {i18n.t('booking.repurchase_package.purchase_button')}
            </Button>
          </ButtonWrapper>
        </DetailsWrapper>
      )}
    </>
  )
}

const DetailsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsWrapper",
  styles: _DetailsWrapper
})

const Message = /*#__PURE__*/styled('div', null, {
  displayName: "Message",
  styles: _Message
})

const ButtonWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
})

export default PackageDetails
